
import store from '@/store';
import UserModule from '@/store/modules/User';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

const userModule = getModule(UserModule, store);

@Component
export default class TestCodeDialog extends Vue {
    public code: string = "";
    public errorMessages: string[] = [];

    get dialogOpen() {
        return userModule.provideCode;
    }

    set dialogOpen(newValue: boolean) {
        if (!newValue) {
        userModule.setProvideCode(false);
        }
    }

    @Watch('dialogOpen')
    onDialogOpenChange(isOpen: boolean) {
        if (!isOpen) {
            return;
        }
        this.errorMessages = [];
        this.$nextTick(() => {
            const input = this.$refs.codeInput as Vue & { focus?: () => void };
            input?.focus?.();
            const nativeInput = (this.$el as HTMLElement | undefined)?.querySelector('input');
            nativeInput?.focus();
            nativeInput?.select();
        });
    }

    public async submit() {
        this.errorMessages = [];
        const trimmedCode = this.code.trim();
        if (!trimmedCode) {
            this.errorMessages = [ 'Kod testera jest wymagany' ];
            return;
        }
        try {
            await userModule.submitRegistrationCode(trimmedCode);
            this.dialogOpen = false;
            this.code = '';
        } catch (e) {
            const responseStatus = (e as any)?.response?.status;
            const responseData = (e as any)?.response?.data;
            const reason = responseData?.reason;
            const errorMessage = responseData?.error;

            if (reason === 'invalidCode') {
                this.errorMessages = ['Błędny kod testera'];
                return;
            }

            if (reason === 'noCode') {
                this.errorMessages = ['Kod testera jest wymagany'];
                return;
            }

            if (responseStatus === 403) {
                this.errorMessages = ['Błędny kod testera'];
                return;
            }

            if (responseStatus === 409) {
                this.errorMessages = ['Konto z tym adresem już istnieje. Spróbuj się zalogować.'];
                return;
            }

            if (responseStatus === 500) {
                this.errorMessages = ['Serwer nie dokończył rejestracji. Spróbuj ponownie za chwilę.'];
                return;
            }

            if (typeof responseStatus === 'number') {
                if (typeof errorMessage === 'string' && errorMessage.length > 0) {
                    this.errorMessages = [errorMessage];
                } else {
                    this.errorMessages = ['Nie udało się zweryfikować kodu. Spróbuj ponownie.'];
                }
                return;
            }

            this.errorMessages = ['Brak połączenia z serwerem. Spróbuj ponownie.'];
        }
    }
}
